import React, { useEffect, useState } from "react";
import { listNotifications, createNotification, deleteNotification } from "../../services/analytics";
import { listCustomers } from "../../services/analytics";
import { Trash2, Send, Bell, Info, Tag, AlertTriangle } from "lucide-react";

const TYPE_ICONS = { info: Info, promo: Tag, warn: AlertTriangle };

export default function AdminNotifications() {
  const [items, setItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", type: "info", target_user_id: "" });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const reload = async () => setItems(await listNotifications());
  useEffect(() => { reload(); listCustomers().then(setUsers); }, []);

  const send = async () => {
    if (!form.title || !form.body) return alert("Başlıq və mətn tələb olunur.");
    setBusy(true);
    try {
      await createNotification({
        title: form.title, body: form.body, type: form.type,
        target_user_id: form.target_user_id || null,
      });
      setMsg("Bildiriş göndərildi ✓");
      setForm({ title: "", body: "", type: "info", target_user_id: "" });
      await reload();
      setTimeout(() => setMsg(""), 2500);
    } finally { setBusy(false); }
  };

  const del = async (n) => {
    if (!window.confirm(`'${n.title}' silinsin?`)) return;
    await deleteNotification(n.id); reload();
  };

  return (
    <div className="p-10" data-testid="admin-notifications">
      <div className="metadata">ELAN</div>
      <h1 className="font-display text-5xl mt-1">Bildirişlər</h1>

      <div className="mt-8 border border-[var(--primary)] p-6">
        <div className="metadata mb-4 flex items-center gap-2"><Bell size={14} className="text-[var(--primary)]" /> YENİ BİLDİRİŞ</div>
        <div className="grid md:grid-cols-2 gap-3">
          <div className="md:col-span-2">
            <label className="metadata">BAŞLIQ <span className="text-[var(--text-muted)] normal-case">— qısa sərlövhə</span></label>
            <input className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="notif-title" placeholder="Yeni endirim!" />
          </div>
          <div className="md:col-span-2">
            <label className="metadata">MƏTN <span className="text-[var(--text-muted)] normal-case">— mesajın tam mətni</span></label>
            <textarea rows={3} className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="notif-body" placeholder="Bütün jazz albomlarına 20% endirim." />
          </div>
          <div>
            <label className="metadata">TİP <span className="text-[var(--text-muted)] normal-case">— ikon növü</span></label>
            <select className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
              <option value="info">Məlumat</option>
              <option value="promo">Promosiya</option>
              <option value="warn">Xəbərdarlıq</option>
            </select>
          </div>
          <div>
            <label className="metadata">HƏDƏF <span className="text-[var(--text-muted)] normal-case">— kimə göndərilsin</span></label>
            <select className="w-full bg-transparent border border-[var(--border)] px-3 py-2 mt-1" value={form.target_user_id} onChange={(e) => setForm({ ...form, target_user_id: e.target.value })}>
              <option value="">Hamıya (bütün müştərilər)</option>
              {users.filter((u) => u.role !== "admin").map((u) => <option key={u.uid} value={u.uid}>{u.email}</option>)}
            </select>
          </div>
        </div>
        {msg && <div className="text-[var(--primary)] text-sm mt-3">{msg}</div>}
        <div className="flex justify-end mt-4">
          <button onClick={send} disabled={busy} className="btn-primary" data-testid="notif-send"><Send size={14} /> {busy ? "…" : "GÖNDƏR"}</button>
        </div>
      </div>

      <div className="mt-8 space-y-3">
        <div className="metadata">GÖNDƏRİLMİŞ BİLDİRİŞLƏR</div>
        {items.length === 0 && <div className="p-10 text-center text-[var(--text-muted)] metadata border border-[var(--border)]">HƏLƏ BİLDİRİŞ YOXDUR</div>}
        {items.map((n) => {
          const Icon = TYPE_ICONS[n.type] || Info;
          const target = n.target_user_id ? users.find((u) => u.uid === n.target_user_id)?.email : null;
          return (
            <div key={n.id} className="border border-[var(--border)] p-4 flex gap-3 group">
              <Icon size={18} className="text-[var(--primary)] mt-1" />
              <div className="flex-1">
                <div className="font-display text-lg">{n.title}</div>
                <div className="text-[var(--text-2)] text-sm mt-1">{n.body}</div>
                <div className="metadata text-[var(--text-muted)] mt-2">
                  {n.created_at?.toDate?.().toLocaleString() || "—"}
                  {" · "}
                  {target ? `Hədəf: ${target}` : "Hamıya"}
                </div>
              </div>
              <button onClick={() => del(n)} className="p-1 text-[var(--text-muted)] hover:text-[var(--accent)] opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`del-notif-${n.id}`}><Trash2 size={14} /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
